import { render, staticRenderFns } from "./juanBanZD.vue?vue&type=template&id=7ff68954&scoped=true&"
import script from "./juanBanZD.vue?vue&type=script&lang=js&"
export * from "./juanBanZD.vue?vue&type=script&lang=js&"
import style0 from "./juanBanZD.vue?vue&type=style&index=0&id=7ff68954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff68954",
  null
  
)

export default component.exports